/**
 * Class TfsManager
 * This util provides a properly formatted smpte timecode for the heartbeat to use in tfs polling.
 * It also can optionally run an interval to advance the given timecode to simulate a live game
 *
 * The primary usage is that this is that if TFS is active, this is the keeper of the current time
 * and the data load classescall getCurrentTimecode() to know what to append to the data query
 */
define('GameDayCore/GDControl/TfsManager/TfsManager',['require','exports','module','../../GDModel/ValueObjects/Resources/SmpteTimecode','datasource-manager/datasource-manager','datasource-manager/env','../GameModelLocator/GameModelLocator','extant/extant','moment'],function(require,exports,module) {
	var SmpteTimecodeVO = require("../../GDModel/ValueObjects/Resources/SmpteTimecode"),
		DataSourceManager = require('datasource-manager/datasource-manager'),
		Environ = require("datasource-manager/env"),
		GameLocator = require("../GameModelLocator/GameModelLocator"),
		exists = require("extant/extant"),
		Moment = require("moment");

	var	POLL_FREQ = 10000,// how often to update
		prefixOs = "",
		timecodeValue, // the time as numbers
		timecodeString, // the time as a string
		smpteTimecode, // the formated time
		previousSmpteTimecode, // the formated time
		pollInterval, // the clock
		syncActive = false, // running or no
		timeMarchesOn = false, // advance? if false, the time stays constant,
		env = Environ().toUpperCase(), //check current environment
		gdxHost = "/gdcross", //default gdcross host is relative
		tfsHost = "/tfs/tfs?file="; //default tfshost is relative

	/**
	 * Funciton init
	 * @param $startTimecode {String} what point to start from
	 * @param FFWD {int} if we care to change the poll frequency
	 * @param startFires {Boolean} advance the time or no (usually yes)
	 *
	 * starts the tfs clock
	 */
	exports.init = function($startTimecode, FFWD, startFires) {
		if (exists($startTimecode)) {
			// format it, set the poll frequency and advancement vars
			exports.setTimecode($startTimecode);
			POLL_FREQ = FFWD * 1000;
			timeMarchesOn = startFires;

			// begin the creation of the 'current' time code.
			this.beginSync(true);
		}

		// else we got nothing to work with
	};

	/**
	 * Function setTimecode
	 * @param $timecode {String}
	 *
	 * does the heavy lifting in getting most formed or malformed time values to smpteTimecode
	 */
	exports.setTimecode = function($timecode) {
		if (!exists($timecode)) {
			// if we got no value, you're stupid and i won't help you
			this.stopSync();
			return;
		}

		var tcode = $timecode.toString(),
			tzone = ($timecode.indexOf("et") >= 0) ? "et" : "",
			tnum = parseInt(tcode);

		prefixOs = setPrefixValue(tcode.length - tnum.toString().length);


		tcode = resolveTimeStringLength((tzone === "") ? tcode : tcode.substr(0, tcode.length - 2));
		tnum = parseInt(tcode); // time  as a num
		tnumString = resolveTimeStringLength(tnum.toString()); // time num as a string (this actually makes sense later)

		// if the 'et' is part of the string adjust from eastern time to GMT
		if (tzone !== "") {
			// extract just the hours from the string
			tcode = resolveTimeZoneDiff(tcode);
			tnum = parseInt(tcode);
			tnumString = tnum.toString();
		}

		// apply our temp vars to the object scope vars
		timecodeValue = tnum;
		timecodeString = resolveTimeStringLength(tnumString);

		// round the timecode to 0 or 5 to cut down on the number of potential unique calls to the server
		if (timecodeString.substr(5, 1) !== 0 || timecodeString.substr(5, 1) !== 5) {
			var lastDigit = parseFloat(timecodeString.substr(5, 1));
			lastDigit = (lastDigit < 5) ? 0 : 5;
			timecodeString = timecodeString.substr(0, 5) + lastDigit.toString();
		}

		previousSmpteTimecode = smpteTimecode;

		// create a smpteTimecodeVO with the resolved timecode string
		smpteTimecode = new SmpteTimecodeVO(timecodeString);

		// reset the time code to what that object has resolved
		// as it handles stuff like making sure we don't have more than 59 seconds or minutes etc
		timecodeString = smpteTimecode.timecode.split(":").join("");
	};

	/**
	 * function setPrefixValue
	 * @param cnt int of how many zeroes to save
	 * @returns {string} a string of that many zeroes
	 *
	 * this is an overengineered function to preserve early 0 countage.
	 */
	function setPrefixValue(cnt) {
		var pre = "";
		for (var i = 0; i < cnt; i++) {
			pre = pre.concat("0");
		}

		return pre;
	}

	/**
	 * private function resolveTimeStringLength
	 * @param $tc {String} timecode as string.
	 * @returns {String} refactored timecode, as string.
	 */
	function resolveTimeStringLength($tc) {
		var tcode = prefixOs + "" + $tc.toString();
		// you can pass just hour, or just hh:mm and this will compensate
		if (tcode.length !== 6) {
			// add extra zeroes, then trim it so length is six characters for hh:mm:sc
			tcode = (tcode.charAt(0) !== "0") ? tcode + "0000000" : "000000" + tcode;
			tcode = (tcode.charAt(0) !== "0") ? tcode.substr(0, 6) : tcode.substr(tcode.length - 6); // this will also deal with accidental extra zeroes passed in
		}

		return tcode;
	}

	/**
	 * private function resolveTimeZoneDiff
	 * @param $tc {String} timecode value, as string
	 * @returns {String} refactored timecode, as string
	 */
	function resolveTimeZoneDiff($tc) {
		var linescore = GameLocator.getGameData("linescore"),
			offset = (exists(linescore)) ? parseInt(linescore.time_zone_hm_lg) : -4, // assumes ET (not daylight savings)
			timeString;

		// extract just the hours from the string
		var hours = parseInt($tc.substr(0, 2)); // during regular season it's not daylight savings so only +4

		hours = hours - offset;
		hours = (hours <= 23) ? hours : hours - 24; // adjust for rolling over midnight

		// append the adjusted hours back to the number string (without the orig hours)
		timeString = "00" + hours.toString() + $tc.substr(2); // the 00 helps with midnight rollover
		return timeString.substr(timeString.length - 6);
	}

	/**
	 * Function incrementTimecode
	 *
	 * Advance the timecode by 10 seconds.
	 * check if the we are to keep advancing.
	 */
	function incrementTimecode() {
		// get the seconds of timecode string, parse to a num then increase it by ten and reappend it to the whole
		var increase = parseInt(timecodeString.substr(timecodeString.length - 2),10) + 10;
		timecodeString = timecodeString.substr(0, timecodeString.length - 2) + increase.toString();

		// parse out the new string
		exports.setTimecode(timecodeString);

		// unless this is the end of the road
		if (!timeMarchesOn) { exports.stopSync(); }
	}

	/**
	 * private function getYMDAddendum
	 * @param tfs {String} timecode value as string
	 * @returns {String} 'yyyymmdd_' to be appended to the tfs value
	 */
	function getYMDAddendum(tfs) {
		var gameObj = GameLocator.getCurrentGame(),
			gameData = GameLocator.getGameData("linescore"),
			leagueTime,
			ymd = "",
			hrs = tfs.substr(0, 2),
			min = tfs.substr(2, 2),
			offset = (exists(gameData, "linescore")) ? parseInt(gameData.linescore.time_zone_hm_lg,10) : 0;


		if (exists(gameData, "linescore")) {
			var gid = gameObj.gid;

			leagueTime = parseInt(hrs,10) + offset;
			ymd = gid.year + "-"  + gid.month + "-" + gid.day;

			var hm = leagueTime + ":" + min;
			var adjust = Moment(ymd + " " + hm, "YYYY-MM-DD HH:mm");

			if (parseInt(leagueTime,10) < 10) {
				adjust.add(1, "days");
			}

			adjust.add(-offset, "hours");

			ymd = adjust.format("YYYYMMDD") + "_";
		}

		return ymd;
	}

	/**
	 * Function beginSync
	 * @param skipImmediateCall {Boolean}
	 *
	 * start the timecode advancing
	 */
	exports.beginSync = function(skipImmediateCall) {
		if (exists(pollInterval)) {
			// stop any interval that was already active
			this.stopSync();
		}

		syncActive = true; // label the class as 'active'
		// if we're not making a call on this current timecode, start advancing now
		if (skipImmediateCall !== true) {
			incrementTimecode();
		}

		// if we are going to advance further, set up an interval to run the increment function
		if (timeMarchesOn) { 
			pollInterval = setInterval(incrementTimecode, POLL_FREQ); 
		}
	};

	/**
	 * Function stopySync
	 *
	 * stopsthe TFS advance interval, if one exists.
	 */
	exports.stopSync = function() {
		if (exists(pollInterval)) {
			clearInterval(pollInterval);
			pollInterval = undefined;
		}

		// set active to false
		syncActive = false;
	};

	/**
	 * Function getTfsHost
	 * @returns {String}
	 *
	 * getter for current server based on whether a tfs timecode is active
	 */
	exports.getTfsHost = function() {
		var dsrc = DataSourceManager.get(env);

		if (dsrc.name === env) {
			gdxHost = dsrc.gd_flat;
			tfsHost = dsrc.gd_tfs;
		}

		return (syncActive) ? tfsHost : gdxHost;
	};

	/**
	 * Function getCurrentTimecode
	 * @returns {String}
	 *
	 * getter for the current time value, or live if no tfs TfsManager is active
	 */
	exports.getCurrentTimecode = function() {
		var tcString;

		if (!syncActive) {
			tcString = "?live";
		} else {
			tcString = "&timecode="
			var tcClock = smpteTimecode.timecode.split(":").join("");
			var tcDate = getYMDAddendum(tcClock);

			tcString = tcString.concat(tcDate, tcClock);
		}

		return tcString;
	};

	exports.getPreviousTimecode = function() {
		var tcString;

		if (!syncActive || !exists(previousSmpteTimecode)) {
			tcString = "?live";
		} else {
			tcString = "&timecode="
			var tcClock = previousSmpteTimecode.timecode.split(":").join("");
			var tcDate = getYMDAddendum(tcClock);

			tcString = tcString.concat(tcDate, tcClock);
		}

		return tcString;
	};

	/**
	 * Function syncActive
	 * @returns {boolean}
	 *
	 * returns true if clock is running
	 */
	exports.syncActive = function() { 
		return syncActive; 
	};

	/**
	 * Function setTimerAdvanceOption
	 * @param $start
	 *
	 * stop or start the clock from advancing without effecting the tfs connection as-is
	 */
	exports.setTimerAdvanceOption = function($start) { 
		timeMarchesOn = $start; 
	}
});
